<template>
  <div>
    <div class="credit">
      <h2 class="title-choose-photo">
        {{ lang['monetary_compensation_new'].SFS_LANG_ROW_1 }}
      </h2>
      <p>{{ InfoPaxMonetaryDetail.currency }} {{ totalAmount }}</p>
    </div>
    <NewTransferWiseForm
      id="monetaryCompensationUpdateTransferWise"
      :wise-bank-detail="InfoPaxMonetaryDetail.bank_info"
      :lang-transfer-wise="lang.monetary_compensation_new"
      :is-name-null="isNameNull"
      :is-type-iban="isTypeIban"
      @updateInfoPaxBank="updateInfoPaxBank"
      @updateIsValidate="updateIsValidate"
    />
    <b-alert
      v-model="showAlertTop"
      class="position-fixed fixed-top m-0 rounded-0"
      style="z-index: 2000; border-radius: 1rem !important; border: 1px solid #ffa5a5; color: #444"
      variant="danger"
      dismissible
    >
      <div v-for="(error, index) in messagesError" :key="index">
        <div>{{ error }}</div>
      </div>
    </b-alert>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { replaceStr } from '@/utils/helper'
import NewTransferWiseForm from '@/components/NewTransferWiseForm/Index'
import { NOT_VALID } from '@/constants/wise-error-code'
import { HTTP_UNPROCESSABLE_ENTITY } from '@/constants/http-status-codes'

export default {
  name: 'MonetaryCompensationUpdate',
  components: {
    NewTransferWiseForm
  },
  props: {
    secret: {
      type: String,
      default: ''
    },
    service: {
      type: Object,
      default: () => {}
    },
    InfoPaxMonetaryDetail: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      infoPaxBank: {},
      messagesError: [],
      showAlertTop: false,
      isNameNull: false,
      isTypeIban: false
    }
  },
  computed: {
    ...mapGetters({}),
    totalAmount() {
      return parseFloat(this.InfoPaxMonetaryDetail.infoCashOrder.amount).toFixed(2) || 0
    }
  },
  watch: {
    showAlertTop() {
      if (this.showAlertTop) {
        setTimeout(() => {
          this.showAlertTop = false
        }, 5000)
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
    replaceStr,
    updateInfoPaxBank(infoPaxBank) {
      this.messagesError = []
      let name = infoPaxBank.params.accountHolderName
      let ibanDetails = infoPaxBank.params.details.IBAN
      if (!name || name === '' || name === null) {
        this.showAlertTop = true
        this.messagesError.push('Enter an account holder name')
        this.isNameNull = true
        return
      } else if (this.isTypeIban && (!ibanDetails || ibanDetails === '' || ibanDetails === null)) {
        this.showAlertTop = true
        this.messagesError.push('Enter IBAN details')
        this.isTypeIban = true
        return
      } else {
        this.showAlertTop = false
        this.isNameNull = false
        this.isTypeIban = false
      }
      this.infoPaxBank = infoPaxBank
      this.processTransferWise()
    },
    processTransferWise() {
      let self = this
      let amount = self.service.price_per_person
      if (self.totalAmount) {
        amount = self.totalAmount
      }
      this.infoPaxBank.amount = amount
      this.infoPaxBank.service_id = self.service.service_id
      this.infoPaxBank.monetary_order_id = self.InfoPaxMonetaryDetail.infoCashOrder.id
      let dataSend = {
        data: {
          info_bank: this.infoPaxBank
        },
        secret: self.secret
      }
      this.$store.dispatch('MonetaryCompensation/saveInfoPaxMonetary', dataSend).then((response) => {
        if (response.success === undefined) {
          self.$swal('Action failed')
          return
        }

        if (response.success === true) {
          this.$store.dispatch('MonetaryCompensation/getDataMoneTary', this.InfoPaxMonetaryDetail.infoCashOrder.issue_monetary_id)
          return
        }

        // EF: Legacy case, currently revolut isn't used but since we have still revolut code all
        //   over the place we keep this in place.
        if (response.revolut_message && response.revolut_message.trim() !== '') {
          self.$swal('Action failed')
          return
        }

        if (response.message?.statusCode === HTTP_UNPROCESSABLE_ENTITY) {
          const error = (response.message?.wsData?.errors || [])[0] || {}
          if (!error.code) {
            self.$swal('Action failed')
          } else if (error.code === NOT_VALID) {
            self.$swal(
              this.lang['monetary_compensation_new']?.SFS_LANG_TRANSFER_WISE_16 ||
                'This account is not validated. Please retype your account details'
            )
          } else {
            self.$swal(
              this.lang['monetary_compensation_new']?.SFS_LANG_TRANSFER_WISE_15 ||
                'Unfortunately it is not possible to transfer money to this country. Please use another bank account or go to the desk for support.'
            )
          }
          return
        }

        self.$swal(
          typeof response.message === 'string' || response.message instanceof String ? response.message : 'Action failed'
        )
      })
    },
    updateIsValidate(nameNull, typeIban) {
      this.messagesError = []
      this.isNameNull = nameNull
      this.isTypeIban = typeIban
      if (this.isNameNull) {
        this.showAlertTop = true
        this.messagesError.push('Enter an account holder name')
      } else if (this.isTypeIban) {
        this.showAlertTop = true
        this.messagesError.push('Enter IBAN details')
      } else {
        this.showAlertTop = false
      }
    }
  }
}
</script>
